import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { MaterialIcon } from '@pearsontechnology/aero-components';

import enhanceWithThemes from 'hocs/enhanceWithThemes';
import themes from 'containers/App/themes';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import SideDrawer from 'components/SideDrawer';

import { PanelContainer, HelpButton, CloseButton } from './styles';
import messages from './messages';
import TabsNavigation from './TabsNavigation';

/**
 * Displays a help button at the bottom of the screen.
 * @param {*} props
 */
function HelpMenuPanel({ ...props }) {
  const { helpContext } = props;
  const [panelOpen, setPanelOpen] = useState(false);
  const panelElementRef = useRef();
  const panelButtonRef = useRef();

  useEffect(() => {
    const handleOuterClick = (event) => {
      if (!panelElementRef.current) return;
      const containsPanel = panelElementRef.current.contains(event.target);

      if (!containsPanel) {
        setPanelOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOuterClick);

    return function cleanup() {
      document.removeEventListener('mousedown', handleOuterClick);
    };
  }, []);

  /**
   * Listen to key presses
   */
  useEffect(() => {
    const handleKeydown = (event) => {
      if (event.code === 'Escape') {
        setPanelOpen(false);
      }
    };
    document.addEventListener('keydown', handleKeydown);
    return function cleanup() {
      document.removeEventListener('keydown', handleKeydown);
    };
  }, []);

  return (
    <PanelContainer ref={panelElementRef} {...props}>
      {!panelOpen &&
        <HelpButton
          onClick={() => setPanelOpen(!panelOpen)}
          ref={panelButtonRef}
          aria-label={intl.formatMessage(messages.helpButton)}
        />
      }
      <SideDrawer
        isOpen={panelOpen}
        drawerWidth={'402px'}
        positionFromRight={'0'}
        positionFromTop={'0'}
        lightBackground="color.white"
        close={() => setPanelOpen(panelOpen)}
        showOverlay={false}
        zIndex='50'
      >
        <TabsNavigation helpContext={helpContext} />
        <CloseButton grey iconOnly onClick={() => setPanelOpen(!panelOpen)} >
          <MaterialIcon id="close" />
        </CloseButton>
      </SideDrawer>
    </PanelContainer>
  );
}

HelpMenuPanel.propTypes = {
  helpContext: PropTypes.string,
};

export default enhanceWithThemes(HelpMenuPanel, themes);
